/**
 * Format a date for display
 */
export function formatDate(date: string | Date | null | undefined, options: { includeTime?: boolean } = {}): string {
  const { includeTime = false } = options

  if (!date) {
    return '-'
  }

  const d = typeof date === 'string' ? new Date(date) : date

  if (includeTime) {
    return d.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    })
  }

  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

/**
 * Simple price formatter
 * Returns '\u2014' for null/undefined values
 */
export function formatPrice(price: number | null | undefined): string {
  if (price == null) return '\u2014'
  return price.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

/**
 * Format a date as a relative time string (e.g. "5m ago", "2h ago", "3d ago").
 * Falls back to a short date for anything older than a week.
 */
export function formatRelativeTime(dateString: string): string {
  const date = new Date(dateString)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)

  if (diffMins < 1) return 'just now'
  if (diffMins < 60) return `${diffMins}m ago`
  if (diffHours < 24) return `${diffHours}h ago`
  if (diffDays < 7) return `${diffDays}d ago`
  return date.toLocaleDateString()
}
